;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.Gauntlet = Backbone.Model.extend({

		url: function() {
			return this.methodUrl;
		},

		isNew: function(){
			return true;
		},

		save_gauntlet: function( data ) {
			this.methodUrl = 'gauntlet/save';
			this.save( {}, {
				data: data,
				ajaxSync: true,
				success: function(model, resp) {
					if ( resp.errors && resp.errors.length ) {
						if ( resp.errors[0].text == 'Team already in streak' ) {
							alert( 'Gauntlet successfully saved!' );
						}
						else {
							alert( resp.errors[0].text );
						}
					}
				},
				error: function(model, resp) {

				}
			});
			return this;
		},

		remove_gauntlet: function ( data ) {
			this.methodUrl = 'gauntlet/remove';
			this.save( {}, {
				data: data,
				ajaxSync: true,
				success: function(model, resp) {
					if ( resp.errors && resp.errors.length ) {
						alert( resp.errors[0].text );
					}
				},
				error: function(model, resp) {

				}
			});
			return this;
		},

		loadSnapshot: function() {
			return this.setApiUrl('gauntlet/snapshot');
		},

		loadPick5Snapshot: function () {
			return this.setApiUrl('tipping_pick5/snapshot');
		}

	});

}(window, APP, Backbone, Marionette, $, _));